import { OPTION_VALUES } from "@ipru-common/constants/InputValues";
import { AGE } from "@ipru-common/constants/SiteConstants";
// import QuoteFormStore from "shared-library";

export const TRULY = ["yes", "y"];
export const FALSY = ["no", "n", ""];

export const trueFalse = (val) => {
  const inputValue = val?.toLowerCase();

  if (TRULY.includes(inputValue)) {
    return true;
  } else if (FALSY.includes(inputValue)) {
    return false;
  } else {
    return "";
  }
};

class CalculatorFormStore {
  constructor() {
    /**
     * @type {CalculatorForm}
     */
    this.calFormData = {};
  }

  setCalFormData(calFormData) {
    this.calFormData = calFormData;
  }

  /**
   * @returns {CalculatorForm}
   */
  getCalFormData() {
    return this.calFormData;
  }

  getFieldValue(fieldName) {
    return this.calFormData[fieldName];
  }

  checkIsNri() {
    return trueFalse(this.calFormData.nri);
  }

  updateFields(fields) {
    this.calFormData = { ...this.calFormData, ...fields };
  }

  checkIsProposer() {
    // if (GlobalStore.getIsAnnuityAppForm()) {
    //   return QuoteFormStore.isJointLife();
    // }
    if (this.calFormData.relation && this.calFormData.relation !== OPTION_VALUES.BUYING_FOR.SELF) {
      return true;
    } else {
      return false;
    }
  }

  checkIsLaMinor() {
    const isProposer = this.checkIsProposer();
    return isProposer && this.calFormData.age < AGE.ADULT_AGE;
  }

  checkIsLaOtherThanSpouse() {
    const isOtherThanSpouse = this.checkIsProposer() && this.calFormData.relation !== OPTION_VALUES.BUYING_FOR.SPOUCE;
    return isOtherThanSpouse;
  }

  checkIsLaHealth() {
    const isLaHealth = !this.checkIsNri() && this.checkIsProposer();
    return isLaHealth;
  }
}

export const CalculatorFormStoreInstance = new CalculatorFormStore();
